import {IssueStatus} from "../../types/action/issue-status";
import {CompanyStatus} from "../../types/company/company-status";
import {Delivery} from "../../types/delivery/delivery";
import {DeliveryStatus} from "../../types/delivery/delivery-status";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import {PreviewDeliveryGroup} from "../../types/schedule/preview-delivery-group";
import {PreviewDeliveryInGroup} from "../../types/schedule/preview-delivery-in-group";
import {
    convertPreviewDeliveryInGroupDtoToDeliveryInGroup
} from "../converter/schedule/preview-delivery-in-group-converter";

export const getDeliveriesInGroupByPreview = (
    preview: PreviewDeliveryGroup[]
): PreviewDeliveryInGroup[] => {
    const deliveries = preview.flatMap((deliveryGroupDto) => {
        return deliveryGroupDto.deliveriesInGroup.map((deliveryInGroupDto) =>
            convertPreviewDeliveryInGroupDtoToDeliveryInGroup(deliveryInGroupDto)
        );
    });
    return [...new Set(deliveries)];
};

export const emptySplitDelivery: Delivery = {
    id: "00000000-0000-0000-0000-000000000000",
    client: {id: "", name: "", phone: "", status: CompanyStatus.Active, roles: [],},
    agency: {id: "", name: "", phone: "", status: CompanyStatus.Active, roles: [],},
    pickUpLocation: {
        id: "",
        road: "",
        jibun: "",
        longitude: 0,
        latitude: 0,
        images: [],
    },
    pickUpAction: {
        type: DeliveryGroupType.DropOff,
        startTimeLimited: "",
        endTimeLimited: "",
        requirement: "",
        estimatedTimeOfArrival: "",
        images: [],
        issueStatus: IssueStatus.None,
        startedAt: "",
        completedAt: "",
        retryCount: 0,
    },
    dropOffLocation: {
        id: "",
        road: "",
        jibun: "",
        longitude: 0,
        latitude: 0,
        images: [],
    },
    dropOffAction: {
        type: DeliveryGroupType.DropOff,
        startTimeLimited: "",
        endTimeLimited: "",
        requirement: "",
        estimatedTimeOfArrival: "",
        images: [],
        issueStatus: IssueStatus.None,
        startedAt: "",
        completedAt: "",
        retryCount: 0,
    },
    pickUpWorkPlace: {name: "", floor: 0, phone: "", detail: "", alias: ""},
    dropOffWorkPlace: {name: "", floor: 0, phone: "", detail: "", alias: ""},
    load: {
        name: "",
        quantity: 0,
    },
    dateToWork: "",
    status: DeliveryStatus.Wait,
    scheduleId: undefined,
    worker: undefined,
    comment: undefined,
    invoiceNumber: undefined,

    pickUpDisabled: false,
    dropOffDisabled: false,
    disabled: false,
};

export const isNotDeliveryWait = (delivery: Delivery): boolean => delivery.status !== DeliveryStatus.Wait
export const isDeliveryWait = (delivery: Delivery): boolean => delivery.status === DeliveryStatus.Wait
